import { Route } from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { hasScopesResolver } from '@mds/ngx-auth';

export const planningRoutes: Route[] = [
  {
    path: 'vehicles',
    title: _('i18n.VehiclePlanning.List.Title'),
    resolve: {
      hasShiftWriteScope: hasScopesResolver(['shifts:write']),
      hasWriteScope: hasScopesResolver(['deployments:write']),
      hasSeriesWriteScope: hasScopesResolver(['deploymentseries:write']),
    },
    loadComponent: () =>
      import('./components/vehicle-planning-list/vehicle-planning-list.component').then(
        (m) => m.VehiclePlanningListComponent,
      ),
  },
  {
    path: 'drivers',
    title: _('i18n.DriverPlanning.List.Title'),
    resolve: {
      hasShiftWriteScope: hasScopesResolver(['shifts:write']),
      hasWriteScope: hasScopesResolver(['deployments:write']),
      hasSeriesWriteScope: hasScopesResolver(['deploymentseries:write']),
    },
    loadComponent: () =>
      import('./components/driver-planning-list/driver-planning-list.component').then(
        (m) => m.DriverPlanningListComponent,
      ),
  },
];
